import * as ReactSelectLib from "react-select"
import ReactSelectCreatable from "react-select/creatable"
import ReactSelectAsync from "react-select/async"

const ReactSelect = ReactSelectLib.default
const Input = ReactSelectLib.components.Input

const CustomSelectInput = (props: any) => {
  return (
    <Input
      style={{ borderColor: null, opacity: 0, height: "3rem" }}
      {...props}
    />
  )
}

const DropdownIndicator: React.FC<DropdownIndicatorProps> = (props) => {
  return (
    <ReactSelectLib.components.DropdownIndicator {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.55078 11.1992L3.80078 7.44922C3.54688 7.21484 3.54688 6.80469 3.80078 6.57031C4.03516 6.31641 4.44531 6.31641 4.67969 6.57031L8 9.87109L11.3008 6.57031C11.5352 6.31641 11.9453 6.31641 12.1797 6.57031C12.4336 6.80469 12.4336 7.21484 12.1797 7.44922L8.42969 11.1992C8.19531 11.4531 7.78516 11.4531 7.55078 11.1992Z"
          fill="#707880"
        />
      </svg>
    </ReactSelectLib.components.DropdownIndicator>
  )
}

interface SelectProps extends ReactSelectLib.Props {
  // Add any custom props here if needed
}

export const Select = (props: SelectProps) => {
  return (
    <ReactSelect
      theme={(theme) => ({
        ...theme,
        spacing: {
          controlHeight: 32,
        },
        colors: {
          primary: "var(--colors-secondary-600)",
          primary75: "var(--colors-secondary-500)",
          primary50: "var(--colors-secondary-300)",
          primary25: "var(--colors-secondary-100)",
          danger: "var(--colors-danger-600)",
          dangerLight: "var(--colors-danger-100)",
          neutral0: "var(--colors-white)",
          neutral5: "var(--colors-grey-100)",
          neutral10: "var(--colors-grey-100)",
          neutral20: "var(--colors-grey-300)",
          neutral30: "var(--colors-grey-300)",
          neutral40: "var(--colors-grey-400)",
          neutral50: "var(--colors-grey-600)",
          neutral60: "var(--colors-grey-600)",
          neutral70: "var(--colors-grey-700)",
          neutral80: "var(--colors-grey-800)",
          neutral90: "var(--colors-grey-900)",
        },
      })}
      styles={{
        container: (baseStyles, state) => ({
          ...baseStyles,
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          boxShadow: state.isFocused
            ? "var(--h-selectize-box-shadow-focus)"
            : "none",
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color: "var(--colors-grey-600)",
          padding: "0 var(--spacing-02)",
        }),
        singleValue: (baseStyles, state) => ({
          ...baseStyles,
          color: "var(--colors-grey-900)",
          padding: "0 var(--spacing-02)",
        }),
        indicatorsContainer: (baseStyles, props) => ({
          ...baseStyles,
          paddingRight: "var(--spacing-02)",
        }),
        menu: (baseStyles, state) => ({
          ...baseStyles,
          border: "0",
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: "3.2rem",
          padding: "var(--h-selectize-padding)",
          color: "var(--colors-grey-900)",
          backgroundColor: state.isSelected
            ? "var(--colors-grey-50)"
            : state.isFocused
              ? "var(--colors-grey-100)"
              : "var(--h-selectize-background)",
          "&:hover, &:focus, &:active, &:focus-within, &:target": {
            backgroundColor: "var(--colors-grey-100)",
          },
        }),
      }}
      classNames={{
        container: (state) => "h-selectize h-selectize--sm",
        menu: (state) => "selectize-dropdown",
        menuList: (state) => "selectize-dropdown-content",
      }}
      components={{
        DropdownIndicator,
        Input: CustomSelectInput,
        IndicatorSeparator: null,
      }}
      {...props}
    />
  )
}

export const CreatableSelect = (props: SelectProps) => {
  return (
    <ReactSelectCreatable
      theme={(theme) => ({
        ...theme,
        spacing: {
          controlHeight: 32,
        },
        colors: {
          primary: "var(--colors-secondary-600)",
          primary75: "var(--colors-secondary-500)",
          primary50: "var(--colors-secondary-300)",
          primary25: "var(--colors-secondary-100)",
          danger: "var(--colors-danger-600)",
          dangerLight: "var(--colors-danger-100)",
          neutral0: "var(--colors-white)",
          neutral5: "var(--colors-grey-100)",
          neutral10: "var(--colors-grey-100)",
          neutral20: "var(--colors-grey-300)",
          neutral30: "var(--colors-grey-300)",
          neutral40: "var(--colors-grey-400)",
          neutral50: "var(--colors-grey-600)",
          neutral60: "var(--colors-grey-600)",
          neutral70: "var(--colors-grey-700)",
          neutral80: "var(--colors-grey-800)",
          neutral90: "var(--colors-grey-900)",
        },
      })}
      createOptionPosition="first"
      formatCreateLabel={(input: string) => `Add ${input}`}
      styles={{
        container: (baseStyles, state) => ({
          ...baseStyles,
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          border: "0",
          boxShadow: state.isFocused
            ? "var(--h-selectize-box-shadow-focus)"
            : "none",
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color: "var(--colors-grey-600)",
          padding: "0 var(--spacing-02)",
        }),
        singleValue: (baseStyles, state) => ({
          ...baseStyles,
          color: "var(--colors-grey-900)",
          padding: "0 var(--spacing-02)",
        }),
        indicatorsContainer: (baseStyles, props) => ({
          ...baseStyles,
          paddingRight: "var(--spacing-02)",
        }),
        menu: (baseStyles, state) => ({
          ...baseStyles,
          border: "0",
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: "3.2rem",
          padding: "var(--h-selectize-padding)",
          color: "var(--colors-grey-900)",
          backgroundColor: state.isSelected
            ? "var(--colors-grey-50)"
            : state.isFocused
              ? "var(--colors-grey-100)"
              : "var(--h-selectize-background)",
          "&:hover, &:focus, &:active, &:focus-within, &:target": {
            backgroundColor: "var(--colors-grey-100)",
          },
        }),
      }}
      classNames={{
        group: (state) => "optgroup",
        groupHeading: (state) => "optgroup-heading",
        container: (state) => "h-selectize h-selectize--sm",
        input: (state) =>
          `selectize-input ${document.activeElement.tagName === "INPUT" ? "focus" : ""}`,
        valueContainer: (state) => "p-0",
      }}
      components={{
        IndicatorSeparator: null,
        MultiValue: (props) => <></>,
        MultiValueRemove: (props) => <></>,
        ClearIndicator: (props) => <></>,
        IndicatorsContainer: (props) => <></>,
      }}
      placeholder={props.placeholder}
      {...props}
    />
  )
}

export const AsyncSelect = (props: SelectProps) => {
  return (
    <ReactSelectAsync
      theme={(theme) => ({
        ...theme,
        spacing: {
          controlHeight: 32,
        },
        colors: {
          primary: "var(--colors-secondary-600)",
          primary75: "var(--colors-secondary-500)",
          primary50: "var(--colors-secondary-300)",
          primary25: "var(--colors-secondary-100)",
          danger: "var(--colors-danger-600)",
          dangerLight: "var(--colors-danger-100)",
          neutral0: "var(--colors-white)",
          neutral5: "var(--colors-grey-100)",
          neutral10: "var(--colors-grey-100)",
          neutral20: "var(--colors-grey-300)",
          neutral30: "var(--colors-grey-300)",
          neutral40: "var(--colors-grey-400)",
          neutral50: "var(--colors-grey-600)",
          neutral60: "var(--colors-grey-600)",
          neutral70: "var(--colors-grey-700)",
          neutral80: "var(--colors-grey-800)",
          neutral90: "var(--colors-grey-900)",
        },
      })}
      styles={{
        container: (baseStyles, state) => ({
          ...baseStyles,
        }),
        control: (baseStyles, state) => ({
          ...baseStyles,
          boxShadow: state.isFocused
            ? "var(--h-selectize-box-shadow-focus)"
            : "none",
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color: "var(--colors-grey-600)",
          padding: "0 var(--spacing-02)",
        }),
        singleValue: (baseStyles, state) => ({
          ...baseStyles,
          color: "var(--colors-grey-900)",
          padding: "0 var(--spacing-02)",
        }),
        indicatorsContainer: (baseStyles, props) => ({
          ...baseStyles,
          paddingRight: "var(--spacing-02)",
        }),
        menu: (baseStyles, state) => ({
          ...baseStyles,
          border: "0",
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: "3.2rem",
          padding: "var(--h-selectize-padding)",
          color: "var(--colors-grey-900)",
          backgroundColor: state.isSelected
            ? "var(--colors-grey-50)"
            : state.isFocused
              ? "var(--colors-grey-100)"
              : "var(--h-selectize-background)",
          "&:hover, &:focus, &:active, &:focus-within, &:target": {
            backgroundColor: "var(--colors-grey-100)",
          },
        }),
      }}
      classNames={{
        container: (state) => "h-selectize h-selectize--sm",
        input: (state) =>
          `selectize-input ${document.activeElement.tagName === "INPUT" ? "focus" : ""}`,
        valueContainer: (state) => "p-0",
        option: (state) => "option",
        group: (state) => "optgroup py-0",
        groupHeading: (state) => "optgroup-heading",
      }}
      components={{
        IndicatorSeparator: null,
        MultiValue: (props) => <></>,
        MultiValueRemove: (props) => <></>,
        ClearIndicator: (props) => <></>,
        IndicatorsContainer: (props) => <></>,
        Input: (props) => (
          <Input
            style={{
              boxShadow: "none !important",
              padding: "0 !important",
              border: "0 !important",
            }}
            {...props}
          />
        ),
      }}
      {...props}
    />
  )
}
